import * as Animate from "react-reveal";

const areas = [
  "AI & Automation",
  "Data",
  "Product",
  "Design",
  "Software Engineering",
  "Cybersecurity",
  "Cloud",
  "Business",
  "Growth",
];

const TrainerExpertiseSection = () => {
  return (
    <section className="bg-hire-tint-blue py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            Expertise areas
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start mb-10">
            <h2 className="lg:col-span-2 text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black max-w-xl tracking-[-0.03em] text-primary">
              Where can you help learners grow?
            </h2>
            <p className="text-gray text-base font-poppins leading-relaxed lg:pt-2">
              Applications are matched to actual Utiva programme needs and
              faculty opportunities.
            </p>
          </div>
        </Animate.Fade>

        <div className="flex flex-wrap gap-3">
          {areas.map((area) => (
            <span
              key={area}
              className="rounded-full bg-white border border-hire-line px-5 py-3 font-poppins text-sm font-bold text-primary"
            >
              {area}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrainerExpertiseSection;
